import { render, staticRenderFns } from "./search-search.vue?vue&type=template&id=5cc84138&scoped=true"
import script from "./search-search.vue?vue&type=script&lang=js"
export * from "./search-search.vue?vue&type=script&lang=js"
import style0 from "./search-search.vue?vue&type=style&index=0&id=5cc84138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc84138",
  null
  
)

export default component.exports